import { Request } from "@/types/request";

export const ROOM_UPGRADE_SERVICE_SYSTEM_KEY = "ROOM_UPGRADE";

export function isRoomUpgradeRequest(request: Request): boolean {
  return Boolean(
    request.bookingRoomUpgradeRequest ||
      request.service?.systemKey === ROOM_UPGRADE_SERVICE_SYSTEM_KEY,
  );
}

export function getRoomUpgradeNumbers(request: Request): {
  currentRoomNumber?: number;
  requestedRoomNumber?: number;
} {
  return {
    currentRoomNumber: request.room?.number || request.booking?.room?.number,
    requestedRoomNumber: request.bookingRoomUpgradeRequest?.upgradeRoom?.number,
  };
}

export function getRoomUpgradeRoomLabel(request: Request): string {
  const { currentRoomNumber, requestedRoomNumber } =
    getRoomUpgradeNumbers(request);

  if (currentRoomNumber && requestedRoomNumber) {
    return `${currentRoomNumber} -> ${requestedRoomNumber}`;
  }

  if (requestedRoomNumber) {
    return String(requestedRoomNumber);
  }

  if (currentRoomNumber) {
    return String(currentRoomNumber);
  }

  return "";
}
